import { AbstractViewProperties } from "../../view/properties/AbstractViewProperties";
import { MouseBlockerProperties } from "./MouseBlockerProperties";
/**
 * DialogManagerProperties.ts
 */
export class DialogManagerProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.2, false);
    }
    equals(other) {
        return super.equals(other) &&
            (this.mouseBlockerProperties.equals(other.mouseBlockerProperties));
    }
}
//# sourceMappingURL=DialogManagerProperties.js.map